// prettier-ignore
export default {
    "language": "it",
    "languages": [
        "en",
        "fr",
        "it"
    ],
    "libraries": [
        "actions",
        "filecheck",
        "cookie",
        "urls",
        "trackers",
        "errors"
    ]
}